export function formatVal(val) {
  if (val === null || val === undefined) return "—";
  if (typeof val === "object") return JSON.stringify(val);
  return String(val);
}

export function formatDate(val) {
  if (val == null || val === "") return "—";
  try {
    const d = new Date(val);
    return Number.isNaN(d.getTime()) ? formatVal(val) : d.toLocaleString();
  } catch {
    return formatVal(val);
  }
}

export function formatINR(num) {
  if (num === null || num === undefined || Number.isNaN(Number(num))) return "—";
  const n = Number(num);
  const hasDecimals = n % 1 !== 0;
  return "₹" + (hasDecimals
    ? n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : n.toLocaleString("en-IN"));
}

export function formatHistoryTimestamp(val) {
  if (!val) return "—";
  try {
    const d = new Date(val);
    if (Number.isNaN(d.getTime())) return String(val);
    const day = String(d.getDate()).padStart(2, "0");
    const month = d.toLocaleString("en-GB", { month: "short" });
    const year = d.getFullYear();
    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${day} ${month} ${year}, ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
  } catch {
    return String(val);
  }
}

export function formatTimelineTimestamp(val) {
  if (!val) return "—";
  try {
    const d = new Date(val);
    if (Number.isNaN(d.getTime())) return String(val);
    const day = d.getDate();
    const month = d.toLocaleString("en-GB", { month: "short" });
    const year = d.getFullYear();
    let h = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    const hh = String(h).padStart(2, "0");
    return `${day} ${month} ${year}, ${hh}:${minutes} ${ampm}`;
  } catch {
    return String(val);
  }
}

const ISO_TS_IN_TEXT_RE = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d+Z/g;

export function formatISOTimestampsInText(text) {
  if (text == null || text === "") return text ?? "";
  const s = String(text);
  return s.replace(ISO_TS_IN_TEXT_RE, (iso) => {
    try {
      const d = new Date(iso);
      if (Number.isNaN(d.getTime())) return iso;
      return (
        d.toLocaleString("en-IN", {
          timeZone: "Asia/Kolkata",
          day: "numeric",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }) + " IST"
      );
    } catch {
      return iso;
    }
  });
}

export function getHistoryTimelineDotClass(actionTaken) {
  const a = (actionTaken || "").toLowerCase();
  if (a.includes("reopened")) return "bg-blue-500";
  if (a.includes("closed")) return "bg-green-500";
  if (a.includes("escalated")) return "bg-orange-500";
  if (a.includes("on hold")) return "bg-yellow-400";
  if (/\bopen\b/i.test(actionTaken || "") && !a.includes("reopened")) return "bg-blue-500";
  if (a.includes("created") || a.includes("assigned")) return "bg-purple-500";
  return "bg-gray-400";
}

export function getHistorySourceIcon(agentName) {
  const n = String(agentName || "").trim();
  if (n === "System") return "⚙️";
  if (n === "Zoho Desk") return "🔗";
  if (/razorpay/i.test(n) || n === "Payment gateway (Razorpay)") return "💳";
  return "🖥️";
}

export function getHistoryTimelineTitle(actionTaken) {
  const t = actionTaken || "";
  if (/created/i.test(t)) return "Ticket Created";
  if (/assigned/i.test(t)) return "Agent Assigned";
  if (/status updated from zoho/i.test(t)) return "Zoho Status Sync";
  if (/status changed/i.test(t)) return "Status Updated";
  if (/closed/i.test(t) && !/reopened/i.test(t.toLowerCase())) return "Ticket Closed";
  if (/on hold/i.test(t)) return "Ticket On Hold";
  if (/escalated/i.test(t)) return "Ticket Escalated";
  if (/refund/i.test(t)) return "Refund Processed";
  if (/comment/i.test(t)) return "Comment Added";
  return "Activity";
}

export function getHistorySourceBadge(agentName) {
  const n = String(agentName || "").trim();
  if (n === "Zoho Desk") {
    return { label: "Zoho Desk", className: "bg-blue-100 text-blue-800" };
  }
  if (n === "System") {
    return { label: "System", className: "bg-gray-100 text-gray-700" };
  }
  if (/razorpay/i.test(n) || n === "Payment gateway (Razorpay)") {
    return { label: "Payment gateway", className: "bg-amber-100 text-amber-900" };
  }
  return { label: "Admin Panel", className: "bg-gray-100 text-gray-700" };
}
